// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3z4JZCyeEKpI19 {\n  border-radius: 32px;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 16px;\n  height: 16px;\n  padding: 2px 8px;\n  text-align: center;\n  text-transform: uppercase;\n}\n.zVxYU57k5ynmXn {\n  background-color: #D6ECD2;\n  color: #49852E;\n}\n._2jOUIx18gHnrpb {\n  background-color: #BCD9EA;\n  color: #094C72;\n}\n._2IXjluC788fsb8 {\n  background-color: #EDDBF4;\n  color: #484553;\n}\n._1OPLJG32GMObV_ {\n  vertical-align: bottom;\n}\n._18qlZgdGdaskaP {\n  display: inline-block;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lozenge": "_3z4JZCyeEKpI19",
	"green": "zVxYU57k5ynmXn",
	"blue": "_2jOUIx18gHnrpb",
	"purple": "_2IXjluC788fsb8",
	"verticallyBottom": "_1OPLJG32GMObV_",
	"inlineFlex": "_18qlZgdGdaskaP"
};
export default ___CSS_LOADER_EXPORT___;
